import CandidatureAddByOrderIdRequest, {
  CandidatureAddByOrderIdRequestBody,
} from "./candidature-add-by-order-id.request";

const createBody = (
  request: CandidatureAddByOrderIdRequest,
): CandidatureAddByOrderIdRequestBody => {
  return {
    acceptImmediately: request.acceptImmediately,
    driverId: request.driverId,
    orderId: request.orderId,
    planEntryId: request.planEntryId,
    taxiCorporationId: request.taxiCorporationId,
  };
};

const candidatureAddByOrderIdRequestFactory = {
  createBody,
};

export default candidatureAddByOrderIdRequestFactory;
